import React, { useEffect, useState, useRef} from 'react';
// import CsvDownloader from 'react-csv-downloader';
import { CSVLink } from 'react-csv';
import DataTable from 'react-data-table-component';
import 'antd/dist/antd.css';
// import { InsuranceReports } from './../../../config/reportName';
import { useHistory } from "react-router-dom";
// import { ToastContainer, toast } from 'react-toastify';
import { UitilityOfflineStatus } from './../../../Utils/Common';
import Invoice from './../../../container/utilityInvoice';

import { INSURANCE_BILL_PAYMENT_REPORT } from './../../../Utils/appConstants';
import { getRequest } from './../../../Utils/AppApi';
// import Moment from 'react-moment';
import { Tooltip, Modal } from 'antd';
import { getUTCToLocalDateTimeFormat, getExportFormat} from '../../../Utils/function';

function InsuranceReport(props) {
    // console.log("props -------",props.search)
    const history = useHistory();
    const csvLink = useRef()
    const limit = 10;
    // const getMode = props.mode ? props.mode : "";
    const startDate = props.startDate ? props.startDate : "";
    const endDate = props.endDate ? props.endDate : "";
    const search = props.search ? props.search : "";
    const searchStatus = props.searchStatus ? props.searchStatus : "";
    
    const [getData, setData] = useState([]);
    const [getCsvData, setCsvData] = useState([]);
    const [getTotalRecord, setTotalRecord] = useState(0);
    const [page, setPage] = useState(1);

    const [isInvoiceModal, setInvoiceModal] = useState(false);
    const [isInvoiceData, setInvoiceData] = useState(null);
    
    const columns = [{
        name: 'Date',
        cell: row => getUTCToLocalDateTimeFormat(row.updatedAt),
        width: "200px"
    }, {
        name: 'Transaction ID',
        cell: row => <span className="pointer" onClick={() => handleInvoice(row)}><u>{row.transactionId}</u></span>,
        width: "180px"
    }, {
        name: 'Provider',
        selector: row => <Tooltip title={row.insuranceproviders.name}>{row.provider}</Tooltip>,
        width: "120px"
    }, {
        name: 'Policy Number',
        selector: row => row.policyNumber,
        width: "150px"
    }, {
        name: 'Due On',
        selector: row => row.dueDateOn,
        width: "150px"
    // }, {
    //     name: 'Date Of Birth',
    //     cell: row => row.dateOfBirth,
    //     width: "150px"
    }, {
        name: 'Mobile',
        selector: row => row.mobile ? row.mobile : '-',
        width: "150px"
    // }, {
    //     name: 'Email Address',
    //     selector: row => row.emailAddress ? row.emailAddress : '-',
    //     width: "180px"
    }, {
        name: 'Amount',
        selector: row => row.amount,
        width: "100px"
    }, {
        name: 'Due Date',
        cell: row => row.duedatefromto,
        width: "120px"
    }, {
        name: 'Status',
        cell: row => <>{UitilityOfflineStatus(row.status)}</>,
    },{
        name: 'Service ID',
        selector: row => row.apiId,
        width: "150px"
    },{
        name: 'Operator ID',
        selector: row => row.operatorId,
        width: "150px"
    },{
        name: 'Action',
        selector: row => <div className='icon-border border border-warning text-warning pointer' onClick={() => handleInvoice(row)} title='Invoice'><i class="fas fa-file-invoice"></i></div>,
        width: "150px"
    }]

    const handleInvoice = (data) => {
        console.log("data --------", data)
        data.electricityproviders = data.insuranceproviders;
        data.accountNumber = data.policyNumber;
        data.billAmount = data.amount;
        setInvoiceModal(true);
        setInvoiceData(data)
    }

    const objectToQueryString = (obj) => {
        var str = [];
        for (var p in obj)
            if (obj.hasOwnProperty(p)) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        return str.join("&");
    }

    const params = {
        page: page,
        limit: limit
    };

    const getDataReports = () => {
        if (startDate && endDate) {
            params.startDate = startDate ? startDate : "";
            params.endDate = endDate ? endDate : "";
        }

        if (search) {
            params.search = search ? search : "";
        }
        if(searchStatus) {
            params.searchStatus = searchStatus ? searchStatus : "";
        }

        const queryString = objectToQueryString(params);
        getRequest(`${INSURANCE_BILL_PAYMENT_REPORT}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                setData(response.data);
                setTotalRecord(response.data.totalDocs);
                setPage(response.data.page);
            } else {
                setData([]);
                setTotalRecord(0);
                setPage(1);
            }
        }).catch(function (error) {
            console.log(error)
            // setLoading(false);
        })
    } // eslint-disable-line react-hooks/exhaustive-deps

    const getCSVDataList = () => {
        let params = {}
        params.exportsCsv = true;
        if (startDate && endDate) {
            params.startDate = startDate ? startDate : "";
            params.endDate = endDate ? endDate : "";
        }

        if (search) {
            params.search = search ? search : "";
        }
        if(searchStatus) {
            params.searchStatus = searchStatus ? searchStatus : "";
        }
        const queryString = objectToQueryString(params);
        getRequest(`${INSURANCE_BILL_PAYMENT_REPORT}?${queryString}`, history).then((response) => {
            if (response.success === true) {
                console.log(" CSV ------------")
                let csvdataRecord = [];
                let csvdata = response.data;
                csvdata.map((e) => {
                    return csvdataRecord.push({
                        "Date": getExportFormat(e.updatedAt),
                        "Transaction ID": e.transactionId,
                        "Provider": e.insuranceproviders.name,
                        "Policy Number": e.policyNumber,
                        "Due On": e.dueDateOn,
                        "Mobile": e.mobile,
                        "Amount": e.amount,
                        "Due Date": e.duedatefromto,
                        "Status": UitilityOfflineStatus(e.status),
                        "Service ID": e.apiId,
                        "Operator ID": e.operatorId
                    });
                });
                // await this.setState({ data: res.data.data, csvdata : csvdata });
                setCsvData(csvdataRecord);
                setTimeout(() => {
                    csvLink.current.link.click();
                }, 1000);
            } else {
                // setCsvData([]);
            }
        }).catch(function (error) {
            console.log(error)
            // setLoading(false);
        })
    }

    const handlePageChange = page => {
        setPage(page);
    };

    const handleHideModal = () => {
        setInvoiceModal(false);
    }

    useEffect(() => {
        getDataReports();
    }, [page, props.handleSearch]) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div>
            <div className="container-fluid pt-2 pb-5">
                <div className="col-md-12">
                    <div className='float-sm-right d-flex mb-1'>
                        <button type="button" className="btn btn-primary mr-3" onClick={() => getCSVDataList()} ><i className="fa fa-file-excel"></i> Export</button>
                        <CSVLink
                            data={getCsvData}
                            filename='insurance-report.csv'
                            className='hidden'
                            ref={csvLink}
                            target='_blank'
                        />
                    </div>
                    <div className="box-body">
                        <DataTable
                            title={''}
                            columns={columns}
                            data={getData.docs}
                            highlightOnHover
                            pagination
                            paginationServer
                            paginationTotalRows={getTotalRecord}
                            onChangeRowsPerPage={getDataReports}
                            onChangePage={handlePageChange}
                        />
                    </div>
                </div>
            </div>
            {isInvoiceModal && <Modal title={<div className='col-md-12 row text-left'>
                <div className='col-md-6'>
                    <img className='text-left' src='../logo.png' alt='photos' width={"50%"} />
                </div>
                {/* <div className='col-md-6 text-right'>
                    <img className='text-right' src={'../images/bharat-billpay-logo-1@2x.png'} alt='photos' width={"40%"} />
                </div> */}
            </div>} width={800} open={isInvoiceModal} footer={false} onCancel={handleHideModal}>
                <Invoice data={isInvoiceData} category="Insurance" />
            </Modal>}
        </div>
    )
}

export default InsuranceReport